import * as React          from 'react'
import { Switch }          from 'react-router'
import { Route }           from 'react-router-dom'
import Login               from "../presentation/containers/LoginContainer";
import LogoutContainer     from "../presentation/containers/LogoutContainer";
import { RouteAfterLogin } from "./RouteAfterLogin";

export class Routes extends React.Component {
  public render() {
    return (
      <Switch>
        <Route exact={ true } path="/" component={ Login }/>
        <Route exact={ true } path="/logout" component={ LogoutContainer }/>
        <RouteAfterLogin/>
      </Switch>
    );
  }
}